export default __webpack_public_path__ + "static/media/pwc.c543c4c8.svg";